import { render, staticRenderFns } from "./ExternalModules.vue?vue&type=template&id=38600796&scoped=true&"
import script from "./ExternalModules.vue?vue&type=script&lang=js&"
export * from "./ExternalModules.vue?vue&type=script&lang=js&"
import style0 from "./ExternalModules.vue?vue&type=style&index=0&id=38600796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38600796",
  null
  
)

export default component.exports